import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';
import type { AuthTokenResponse } from './use-create-customer';

type Variables = { token: string; newPassword: string };

export const useLoginCustomerConfirmPassword = createMutation<
  AuthTokenResponse,
  Variables,
  AxiosError
>({
  mutationFn: async ({ token, newPassword }) =>
    client({
      url: 'v2/password-reset-confirm',
      method: 'POST',
      data: {
        token,
        new_password: newPassword,
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
